<template>
    <div id="customer_class_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerClassHeader" v-if="$route.params.id > 0">Update Customer Class</span>
                    <span class="page-title" id="customerClassHeader" v-else>Add Customer Class</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackCustomerClassList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-class-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="CustomerClassForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateCustomerClassBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCustomerClass" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateCustomerClassBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCustomerClass" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCustomerClassBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCustomerClass(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCustomerClassBtn" class="btn btn-tertiary" v-on:click.prevent="BackCustomerClassList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "LocationCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Customer Class | " +process.env.COPYRIGHT_NAME : "Create Customer Class | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    description: "",
    loading:false,
    name_error_msg: "",
    code_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_customer_class') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadCustomerClass();
            }
        }, 100);
  },
  methods: {

    BackCustomerClassList() {
      var self = this;
      self.$router.push("/customerclass/list");
    },

    CreateCustomerClass(flag) {
      var self = this;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.name_error_msg = "";
      self.code_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
      }
      
      if (self.name_error_msg == "" && self.code_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateCustomerClassBtn").val("Updating ...");
                $("#CreateCustomerClassBtn").prop("disabled", true);
                $("#cancelCustomerClassBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCustomerClassBtn").val("Saving ...");
                    $("#CreateCustomerClassBtn").prop("disabled", true);
                    $("#createAndContinueCustomerClassBtn").prop("disabled", true);
                    $("#cancelCustomerClassBtn").prop("disabled",true);

                }else{

                    $("#CreateCustomerClassBtn").val("Saving ...");
                    $("#CreateCustomerClassBtn").prop("disabled", true);
                    $("#createAndContinueCustomerClassBtn").prop("disabled", true);
                    $("#cancelCustomerClassBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/customerclass/create",
                type: "POST",
                data: {name: self.name, id: segments[3], code: self.code, description: self.description},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCustomerClassBtn").val("Update");
                        $("#CreateCustomerClassBtn").prop("disabled", false);
                        $("#cancelCustomerClassBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCustomerClassBtn").val("Save and Continue");
                            $("#CreateCustomerClassBtn").prop("disabled", false);
                            $("#createAndContinueCustomerClassBtn").prop("disabled", false);
                            $("#cancelCustomerClassBtn").prop("disabled",false);

                        }else{

                            $("#CreateCustomerClassBtn").val("Save");
                            $("#CreateCustomerClassBtn").prop("disabled", false);
                            $("#createAndContinueCustomerClassBtn").prop("disabled", false);
                            $("#cancelCustomerClassBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#CustomerClassForm").trigger("reset");
                            self.name ="";
                            self.code = "";
                            self.description = "";
                    
                        }else{
                            self.$router.push("/customerclass/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCustomerClassBtn").val("Update");
                        $("#CreateCustomerClassBtn").prop("disabled", false);
                        $("#cancelCustomerClassBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#CustomerClassForm").trigger("reset");
                            

                            $("#createAndContinueCustomerClassBtn").val("Save and Continue");
                            $("#CreateCustomerClassBtn").prop("disabled", false);
                            $("#createAndContinueCustomerClassBtn").prop("disabled", false);
                            $("#cancelCustomerClassBtn").prop("disabled",false);

                        }else{

                            $("#CreateCustomerClassBtn").val("Save");
                            $("#CreateCustomerClassBtn").prop("disabled", false);
                            $("#createAndContinueCustomerClassBtn").prop("disabled", false);
                            $("#cancelCustomerClassBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'cust-class-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
     
    },

    loadCustomerClass() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/customerclass/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.code = data.content.code;
                    self.description = data.content.description;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'cust-class-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CustomerClassCreate.vue